import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import Icon from 'shared/components/Icon';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import classes from './FlashMessage.module.scss';

const ICONS_FOR_FLASH_TYPE = {
  default: 'info-circle',
  success: 'check-circle',
  error: 'x-circle',
  warning: 'exclamation-triangle',
  info: 'info-circle',
};

const FlashMessage = props => {
  const { id, isOpen, title, message, flashType } = props.flashMessage;
  const iconName = ICONS_FOR_FLASH_TYPE[flashType] || ICONS_FOR_FLASH_TYPE.default;
  const containerClass = isOpen ? cx(classes.container, classes.open) : classes.container;
  const innerClasses = cx(classes[flashType], classes.flash_message);
  const htmlId = `FlashMessage--${flashType}`;

  return (
    <div data-spec-id={htmlId} className={containerClass}>
      <div className={innerClasses}>
        <div className={classes.icon_container}>
          <Icon name={iconName} />
        </div>

        <button
          className={classes.close_btn}
          onClick={() => FlashMessageActions.dismissFlashMessage({ id })}
        >
          <Icon name="cross" />
        </button>

        <div className={classes.title}>{title}</div>
        <div className={classes.message}>{message}</div>
      </div>
    </div>
  );
};

FlashMessage.displayName = 'FlashMessage';

function mapStateToProps(state) {
  return {
    flashMessage: state.flashMessage,
  };
}

export default connect(mapStateToProps)(FlashMessage);
